import EventDispatcher = createjs.EventDispatcher;

export class FileReference extends EventDispatcher {

    public save(data: any, defaultFileName: string | null = null): void {

    }
}